<template>
    <component :is="wrapInAppContent ? 'app-content' : 'div'">
        <app-content-body>
            <div class="inner" v-if="!templateId">
                <p class="buttons">
                    <a
                        class="btn btn_action btn_add"
                        :title="translations.addBlackoutContent"
                        @click.prevent="createItem"
                    ></a>
                </p>
                <h1 v-translate>Blokovaný obsah</h1>
            </div>
            <app-table
                clickable
                deletable
                highlight-rows-on-hover
                :data="items"
                :order="params.order"
                :page-size="params.limit"
                :loading="listLoading"
                @sort="sortItems"
                @rowClick="goToDetail"
                @deleteRow="deleteItem"
            >
              <template slot="header">
                <app-table-header-item class="field_left">
                  <app-table-header-select :label="translations.epgChannel">
                    <app-select
                        :options="tvStationsOptions"
                        v-model.trim="params.epgId"
                        @change="fetchItems(true)"
                    />
                  </app-table-header-select>

                  <app-input
                      :label="translations.fromTimestampTS"
                      name="fromTimestamp"
                      type="number"
                      v-model="fromTimestamp"
                  />

                  <app-input
                      :label="translations.toTimestampTS"
                      name="toTimestamp"
                      type="number"
                      v-model="toTimestamp"
                  />
                </app-table-header-item>
                <app-table-header-item class="field_right">
                  <app-table-header-select :label="translations.enabled">
                    <app-select
                        :options="activeSelect"
                        v-model.trim="params.enabled"
                        @change="fetchItems(true)"
                    />
                  </app-table-header-select>

                  <app-table-header-select :label="translations.backoffice">
                    <app-select
                        :options="backofficeOptions"
                        v-model.trim="params.backofficeId"
                        @change="fetchItems(true)"
                    />
                  </app-table-header-select>

                  <app-checkbox
                      v-if="isAddGlobalRecordsEnabled"
                      name="addGlobal"
                      v-model="params.addGlobal"
                      @change="fetchItems(true)"
                      :title="translations.addGlobalRecords"
                      class="checkbox-disabled"
                  />

                  <app-input
                    :label="translations.searchName"
                    name="search"
                    type="search"
                    v-model="search"
                    @change="fetchItems(true)"
                  />

                </app-table-header-item>
              </template>

                <app-table-column first attribute="_epgChannelName" sortable :label="translations.epgChannel">
                    <template slot-scope="row">
                      <template v-if="row.backofficeIds.length === 0">
                        <strong>
                          {{ row._epgChannelName }}
                        </strong>
                        (#{{ row.epgId }})
                      </template>
                      <template v-else>
                      <span class="dotted">
                        <strong>{{ row._epgChannelName }}</strong> (#{{ row.epgId }})
                        <span class="help_popup help_popup--no-wrap">
                          <strong>{{ translations.applyToSelectedBackoffices }}</strong> <br />

                          <table style="margin-top: 10px;">
                            <thead>
                              <th class="first_data">Název</th>
                              <th>API Url</th>
                            </thead>
                            <tr v-for="backoffice in row._backoffices" :key="backoffice.id">
                              <td>{{ backoffice.name }}</td>
                              <td>{{ backoffice.api_url }}</td>
                            </tr>
                          </table>
                         </span>
                      </span>
                    </template>
                  </template>
                </app-table-column>
                <app-table-column attribute="name" sortable :label="translations.name">
                    <template slot-scope="row">
                        {{ row.name }}
                    </template>
                </app-table-column>
                <app-table-column attribute="fromTimestamp" sortable :label="translations.fromTimestamp">
                  <template slot-scope="row">
                    <div v-html="formatDate(row.fromTimestamp)" />
                  </template>
                </app-table-column>
                <app-table-column attribute="toTimestamp" sortable :label="translations.toTimestamp">
                  <template slot-scope="row">
                    <div v-html="formatDate(row.toTimestamp)" />
                  </template>
                </app-table-column>

                <app-table-column :label="translations.enabled">
                  <template slot-scope="row">
                    <app-graphic-image
                        :value="row.enabled"
                    />
                  </template>
                </app-table-column>
                <app-table-column :label="translations.allowTs">
                  <template slot-scope="row">
                    <app-graphic-image
                        :value="row.allowTs"
                    />
                  </template>
                </app-table-column>
                <app-table-column :label="translations.allowCatchup">
                  <template slot-scope="row">
                    <app-graphic-image
                        :value="row.allowCatchup"
                    />
                  </template>
                </app-table-column>
                <app-table-column :label="translations.allowPvr">
                  <template slot-scope="row">
                    <app-graphic-image
                        :value="row.allowPvr"
                    />
                  </template>
                </app-table-column>

                <app-table-column sortable attribute="updated" :label="translations.updated">
                    <template slot-scope="row">
                        <div v-html="formatDate(row._updated)" />
                    </template>
                </app-table-column>

                <template slot="footer" v-if="itemsMetadata.totalCount > params.limit">
                  <app-table-pagination
                      :page="listPage"
                      :itemsPerPage="params.limit"
                      :totalCount="itemsMetadata.totalCount"
                      @pageChanged="tablePageChanged"
                  />
                </template>
            </app-table>
        </app-content-body>
    </component>
</template>
<script>
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { mapActions, mapState } from 'vuex'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'BlackoutContents',
  detailRouteName: 'blackoutContent'
})

export default {
  name: 'blackoutContents',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin()],
  data() {
    return {
      fromTimestamp: null,
      toTimestamp: null,
      search: ''
    }
  },
  created() {
    if (this.templateId) {
      this.params.templateId = this.templateId
    } else {
      this.params.templateId = null
    }

    this.getTvStationsOrderedByName()
    this.getBackoffices()

    this.fromTimestamp = this.params.fromTimestamp
    this.toTimestamp = this.params.toTimestamp
    this.search = this.params.search

    this.fetchItems(true)
  },
  methods: {
    ...mapActions([
      'getTvStationsWithBlackout',
      'getBlackoutContents',
      'getBackoffices'
    ]),
    shouldRefreshOnCreate() {
      return false
    },
    getTvStationsOrderedByName() {
      this.getTvStationsWithBlackout({
        params: {
          templateId: this.templateId || null
        }
      })
    }
  },
  computed: {
    ...mapState({
      tvStationsOptions: (state, vm) => {
        return [
          {
            value: null,
            name: 'Všechny kanály'
          },
          ...state.blackoutContents.tvStations.map(({ _id, name }) => ({
            value: _id,
            name
          }))
        ]
      },
      backofficeOptions: (state, vm) => {
        return [
          {
            value: null,
            name: 'Nevybráno'
          },
          {
            value: -1,
            name: 'Bez určení Backoffice'
          },
          ...state.backoffices.backoffices.map(({ _id, name }) => ({
            value: _id,
            name: name
          }))
        ]
      }
    }),
    translations() {
      return {
        searchName: this.$gettext('Název'),
        addGlobalRecords: this.$gettext('Zobrazit záznamy bez určení Backoffice'),
        applyToSelectedBackoffices: this.$gettext('Blokování je aplikováno pouze na vybrané Backoffice.'),
        backoffice: this.$gettext('Backoffice'),
        universalBlock: this.$gettext('Univerzální blokace'),
        epgChannel: this.$gettext('EPG Kanál'),
        fromTimestamp: this.$gettext('Blokovat od'),
        fromTimestampTS: this.$gettext('Blokovat od (ts)'),
        toTimestamp: this.$gettext('Blokovat do'),
        toTimestampTS: this.$gettext('Blokovat do (ts)'),
        enabled: this.$gettext('Povoleno'),
        allowTs: this.$gettext('TS'),
        allowCatchup: this.$gettext('CU'),
        allowPvr: this.$gettext('PVR'),
        addBlackoutContent: this.$gettext('Přidat blokovaný obsah'),
        name: this.$gettext('Název'),
        apiUrl: this.$gettext('API Url'),
        updated: this.$gettext('Upraveno')
      }
    },
    currentTitle() {
      return this.parentTitle ? this.parentTitle : [
        this.$gettext('Blokovaný obsah')
      ]
    },
    activeSelect() {
      return [
        { name: this.$gettext('Nevybráno'), value: null },
        { name: this.$gettext('Ano'), value: true },
        { name: this.$gettext('Ne'), value: false }
      ]
    },
    isAddGlobalRecordsEnabled() {
      return ~~this.params.backofficeId > 0
    }
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal.length >= 2) {
        this.params.search = this.search
        this.fetchItems()
      } else if (newVal.length < 2 && oldVal.length >= 2) {
        this.params.search = ''
        this.fetchItems()
      }
    },
    fromTimestamp: function (newVal, oldVal) {
      if (newVal) {
        this.params.fromTimestamp = this.fromTimestamp
      } else {
        this.params.fromTimestamp = null
      }
      this.fetchItems()
    },
    toTimestamp: function (newVal) {
      if (newVal) {
        this.params.toTimestamp = this.toTimestamp
      } else {
        this.params.toTimestamp = null
      }
      this.fetchItems()
    }
  },
  props: {
    templateId: {
      type: Number,
      required: false
    },
    wrapInAppContent: {
      type: Boolean,
      required: false,
      default: true
    },
    parentTitle: {
      type: Array,
      required: false
    }
  }
}
</script>
